import React, { useLayoutEffect, useRef, useState } from "react";
import "./ShiftPatternShiftTag.scss";

/** Chip compacto de turno (paleta y celdas del calendario). */
const ShiftPatternShiftTag = ({
	name,
	intervalLabels = [],
	className = "",
	style,
	title,
}) => {
	const hasTimes = intervalLabels.length > 0;
	const isCompact = (className || "").includes("sp-shift-tag--sm");
	const rootRef = useRef(null);
	const [stacked, setStacked] = useState(false);

	const intervalsKey = intervalLabels.join("\0");

	useLayoutEffect(() => {
		if (!hasTimes || !isCompact) {
			setStacked(false);
			return;
		}

		const root = rootRef.current;
		if (!root) return;

		const measure = () => {
			const code = root.querySelector(".sp-shift-tag__code");
			const times = root.querySelector(".sp-shift-tag__times");
			if (!code || !times) {
				setStacked(false);
				return;
			}
			if (root.clientWidth === 0) return;

			const cs = getComputedStyle(root);
			const padX =
				parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight) || 0;
			const gap =
				parseFloat(cs.columnGap) ||
				parseFloat(cs.gap) ||
				parseFloat(cs.rowGap) ||
				6;
			const available = root.clientWidth - padX;

			const prevWs = code.style.whiteSpace;
			code.style.whiteSpace = "nowrap";
			const wCode = code.scrollWidth;
			const wTimes = times.scrollWidth;
			code.style.whiteSpace = prevWs;

			setStacked(wCode + gap + wTimes > available + 1);
		};

		const ro = new ResizeObserver(measure);
		ro.observe(root);
		measure();

		return () => ro.disconnect();
	}, [hasTimes, isCompact, name, intervalsKey]);

	const stackedClass =
		hasTimes && isCompact && stacked ? "sp-shift-tag--stacked" : "";

	return (
		<div
			ref={rootRef}
			className={[
				"sp-shift-tag",
				hasTimes ? "sp-shift-tag--has-times" : "",
				stackedClass,
				className || "",
			]
				.filter(Boolean)
				.join(" ")}
			style={style}
			title={title}
		>
			<span className="sp-shift-tag__code">{name}</span>
			{hasTimes && (
				<span className="sp-shift-tag__times">
					{intervalLabels.map((label, i) => (
						<span key={i} className="sp-shift-tag__time-line">
							{label}
						</span>
					))}
				</span>
			)}
		</div>
	);
};

export default ShiftPatternShiftTag;
